import { Box, SvgIconTypeMap, Typography } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { ReactElement } from "react";

interface LabeledTextFieldProps {
  LabelIcon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  label: string;
}

export default function LabeledTextField({ LabelIcon, label }: LabeledTextFieldProps): ReactElement {
  return (
    <Box sx={{ display: "flex" }}>
      <LabelIcon sx={{ color: "icon.main" }} />
      <Typography sx={{ ml: 1, fontWeight: "500" }}>{label}</Typography>
    </Box>
  );
}
